/* 业务公共函数集 */
import Vue from 'vue';
import Store from '../store/index.js';
import Router from '../router/router.js';
import { Message, Notification } from 'element-ui';
import { setStore } from './tools.js';
import { requestApi } from '@/service/requestApi.js';

/*
    操作权限控制
    @param {string} key
    @param {boolean} hideMsg
    @return {boolean}
*/
export const widgetsControl = (key, hideMsg) => {
    const widgets = Store.getters.getCurAuthByAction;
    const hasPass = _.findLastIndex(widgets, item => {
        return item.action === key
        && item.status === 1
    }) !== -1;
    if (!hasPass && !hideMsg) {
        // Message({
        //     type: 'warning',
        //     message: '抱歉，您没有此操作权限。如有需要，请联系管理员赋予权限。',
        //     duration: 1500
        // });
        Notification({
            title: `抱歉，您没有此操作权限`,
            type: 'warning',
            duration: 3000,
            dangerouslyUseHTMLString: true,
            message: '如有需要，请联系<a href="tencent://message/?uin=413750188" title="麦振升-知凡" style="color: #20a0ff">麦振升-知凡</a>赋予权限。'
        });
    }
    return hasPass;
}

/*
    找权限点（待优化）
    @param {array} arr
    @param {string | number} fid
    @param {string} key
    @return {boolean}
*/
export const getItemById = function (arr, fid, key) {
    let tmpObj = {};
    let _fn = function (arr) {
        for (let i = 0; i < arr.length; i ++) {
            let item = arr[i];
            if (item[key] && item[key] == fid) {
                tmpObj = item;
                break;
            }
            if (item.child && item.child.length) {
                _fn(item.child);
            }
        }
    }
    if (arr.length) {
        _fn(arr);
    }
    return tmpObj;
}

export const serviceUrl = function({project, is_t, env = 1}) {
    // let project = this.form.project_id; //项目号
    // let env = 1; //环境,1(预览模式，调用未同步数据)、非1(生产环境模式，调用已同步数据)
    // let is_t = this.isTempPJ; //是否模板项目, 1(模板项目)、非1(子项目)
    let host = window.location.origin;
    let url = is_t ? '/api/acttemp/pj/' : '/api/acttempsub/pj/';
    let fullUrl = `${host}${url}${project}`;
    console.group("数据预览");
    console.log(`未同步数据： ${fullUrl}?env=1`);
    console.log(`已同步数据： ${fullUrl}`);
    console.groupEnd();
    if (env) {
        fullUrl = `${fullUrl}?env=${env}`;
    }
    return fullUrl;
}

export const genFrameSrc = function({ temp_url, project, is_t, e = 1, page_query = [] }) {
    let commonQuery = [
        {
            key: 'pj',
            name: project
        }
    ];
    if (is_t) {
        commonQuery.push({
            key: 'is_t',
            name: is_t ? 1 : 0
        });
    }
    if (e) {
        commonQuery.push({
            key: 'e',
            name: e
        });
    }
    let tmpStr = _.map(_.concat(commonQuery, page_query), (item) => {
        return `${item.key}=${item.name}`;
    }).join('&');
    return `${temp_url}?${tmpStr}`;
}

export const bus = new Vue();

export const postErrMsg = (msg, project_id, uin) => {
	setTimeout(() => {
        let errInfo = {
            "id": project_id,
            "uin": uin,
            "msg": msg,
            "from": window.location.href
        };
        requestApi({
            method: 'post',
            url: 'https://error.youjyi.cn/api/errrorlog/receive',
            body: errInfo,
            successFn: (data) => {
                
            }
        }).then(() => {
        });
    }, 500);
}



// WEBPACK FOOTER //
// ./src/utils/helper.js